import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GameCollectionWithGames } from '@gains-com/shared';
import { environment } from '../../../environments/environment.js';
import { Observable, catchError, map, of, take } from 'rxjs';

interface GameCollectionsResponse {
  count: number;
  data: GameCollectionWithGames[];
}

@Injectable({
  providedIn: 'root',
})
export class GameCollectionService {

  private readonly _http = inject(HttpClient);

  listGameCollections$(isMerch: boolean): Observable<GameCollectionWithGames[]> {
    return this._http
      .get<GameCollectionsResponse>(`${environment.apiUrl}/game-collections`, {
        params: { is_merch: isMerch },
        transferCache: false
      })
      .pipe(
        take(1),
        map(response => response.data),
        catchError(err => {
          console.error('Error fetching game collections:', err);
          return of([]);
        })
      );
  }
}
